import { Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { hasUnapprovedInputsState } from '~/state/atoms/structureSet/structureSetAtoms';

/**
 * Warning banner shown at workflow entry (Dose+, Adapt+, …) when the
 * selected structure set is not approved. Renders nothing when inputs
 * are approved or no structure set is loaded, so it can be dropped into
 * any workflow modal unconditionally.
 *
 * Kept vertically compact (tight padding, single line) so dropping it
 * into a height-constrained modal does not squash the content below it.
 */
export default function UnapprovedInputsWarning() {
    const hasUnapprovedInputs = useRecoilValue(hasUnapprovedInputsState);

    if (!hasUnapprovedInputs) {
        return null;
    }

    return (
        <Alert
            severity="warning"
            variant="outlined"
            sx={{
                py: 0.25,
                alignItems: 'center',
                '& .MuiAlert-icon': {
                    py: 0,
                    mr: 1,
                    fontSize: 20,
                },
                '& .MuiAlert-message': {
                    py: 0.3,
                },
            }}
        >
            <FormattedMessage id="inputsUnapprovedWarning" />
        </Alert>
    );
}
